<template>
  <div style="width: 100%; height: 100%;">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return{}
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue